import { createFileRoute } from '@tanstack/react-router'
import { CallbackPage } from '@/pages/callback'

type CallbackSearch = {
  code?: string
}

export const Route = createFileRoute('/callback')({
  validateSearch: (search: Record<string, unknown>): CallbackSearch => {
    return {
      code: typeof search['code'] === 'string' ? search['code'] : undefined,
    }
  },
  component: CallbackPage,
})
